import VideoEmbedContentBlock from "./functional";
export default VideoEmbedContentBlock;
